import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-chips',
  templateUrl: './add-chips.component.html',
  styleUrls: ['./add-chips.component.scss']
})
export class AddChipsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
